import {Component} from '@angular/core';

@Component({
  selector: 'app-do-you-save-dialog',
  templateUrl: 'do-you-save-dialog.component.html',
  styles: ['do-you-save-dialog.component.less']
})
export class DoYouSaveDialogComponent {}
